// import tab from './tab'
// import auth from './auth'
// import cache from './cache'
import modal from './modal'
import LoginModal from './LoginModal'
import GtagPlugin from '@/utils/gtagHelper'
// import download from './download'

export default {
  install(Vue, options = {}) {
    
    // 页签操作
    // Vue.prototype.$tab = tab
    // 认证对象
    // Vue.prototype.$auth = auth
    // 缓存对象
    // Vue.prototype.$cache = cache
    // 模态框对象
    Vue.prototype.$modal = modal
    Vue.prototype.$login = LoginModal
    // 下载文件
    // Vue.prototype.$download = download
    
    // 注册 Google Analytics 插件，传递初始IP等配置选项
    Vue.use(GtagPlugin, {
      // 可以从options或其他来源获取初始IP
      initialIP: options.initialIP
    })
  }
}
